import React, { useCallback, useState } from 'react'

import GoogleAssetGroupAudienceForm from './GoogleAssetGroupAudienceForm'
import GoogleAssetGroupCreateForm from './GoogleAssetGroupMainForm'

import useContinuousForm from '../../../../../../hooks/formHooks/useContinuousForm'
import useIsInternalAdCreation from '../../../../../../features/hooks/internalAdHooks/useIsInternalAdCreation'

const MAIN_FORM = 'main_form'
const AUDIENCE_FORM = 'audience_form'

const GoogleAssetGroupForm = ({ onSuccessSubmit, formProgressItems }) => {
  const [assetGroupCreatedData, setAssetGroupCreatedData] = useState({})

  const isInternalAssetGroupCreation = useIsInternalAdCreation()

  const { activatedForm, setActivatedForm } = useContinuousForm({
    initialForm: MAIN_FORM
  })

  const onSuccessMainFormSubmit = useCallback(
    assetGroupData => {
      setAssetGroupCreatedData(assetGroupData)
      setActivatedForm(AUDIENCE_FORM)
    },
    [setActivatedForm]
  )

  switch (activatedForm) {
    case AUDIENCE_FORM:
      return (
        <GoogleAssetGroupAudienceForm
          assetGroupCreatedData={assetGroupCreatedData}
          formProgressItems={formProgressItems}
          isInternalAssetGroupCreation={isInternalAssetGroupCreation}
          onSuccessSubmit={onSuccessSubmit}
        />
      )
    case MAIN_FORM:
    default:
      return (
        <GoogleAssetGroupCreateForm
          formProgressItems={formProgressItems}
          isInternalAssetGroupCreation={isInternalAssetGroupCreation}
          onSuccessSubmit={onSuccessMainFormSubmit}
        />
      )
  }
}

export default GoogleAssetGroupForm
